module.exports = __webpack_public_path__ + "static/media/portraitWeb.1ac857ba.jpg";